/**
 * Что показать в модалке «Замеры зафиксированы!» вместо обещания награды.
 *
 * #526: чип «+1 XP» был захардкожен в MeasurementsCongrats и показывался всегда,
 * когда геймификация включена. Обе половины были неправдой: замеры стоят
 * XP_REWARDS.MEASUREMENTS.xp (не 1), и при повторной сдаче за тот же день
 * начисления нет вовсе — recordStreakOncePerDay считает это дубликатом.
 *
 * Теперь число приходит с сервера (`xpAwarded` в ответе POST /diary/measurements)
 * и экран его только отображает. Тот же принцип, что в #521 для кардио: UI не
 * пересчитывает награду сам, а показывает факт начисления.
 */
export type MeasurementsReward =
  /** XP начислен — показываем ровно столько, сколько пришло с сервера. */
  | { kind: 'xp'; xp: number }
  /** Замеры за прошлый день: запись сохранена, XP не положен (#221). */
  | { kind: 'past-day' }
  /** Повтор за сегодня: засчитано, но начисление уже было. */
  | { kind: 'repeat' }
  /** Награды выключены (демо/завершённый поток) — блок наград не показываем. */
  | { kind: 'none' }

export function measurementsReward(input: {
  rewardsOn: boolean
  /** Фактически начисленный XP из ответа API. undefined = ответа нет ⇒ не обещаем. */
  xpAwarded?: number | null
  pastDay?: boolean
}): MeasurementsReward {
  if (!input.rewardsOn) return { kind: 'none' }

  const raw = input.xpAwarded
  const xp = typeof raw === 'number' && Number.isFinite(raw) && raw > 0 ? raw : 0
  if (xp > 0) return { kind: 'xp', xp }

  return input.pastDay ? { kind: 'past-day' } : { kind: 'repeat' }
}
